import {createPrivateCustomer} from '@/api/Courses/CreatePrivateCustomer'
import {fetchCustomerRegistrationRelations} from '@/api/Courses/FetchCustomerRegistrationRelations'
import {fetchVehicleInformation} from '@/api/Courses/FetchVehicleInformation'
import {deleteCustomerRegistrationRelation} from '@/api/Courses/DeleteCustomerRegistrationRelation'
import {createCustomerRegistrationRelation} from '@/api/Courses/CreateCustomerRegistrationRelation'
import {generateUserVerificationCode} from '@/api/Courses/GenerateUserVerificationCode'
import {logInCriipto} from '@/api/LogInCriipto'

import {getUser} from '@/api/Courses/GetUser'
import {getAllowedOrganisations} from '@/api/Courses/GetAllowedOrganisations'

export default {
    state: {
        processing: false,
        userLoggedIn: false,
        userLoggedInToCustomerPortalApi: null,

        userCreated: false,
        givenName: null,
        familyName: null,
        email: null,
        phoneNumber: null,

        address: null,
        zipCode: null,
        city: null,

        fullName: null,
        criiptoIdentifier: null,
        ssn: null,
        criiptoJwtToken: null,

        criiptoTestMode: false
    },
    getters: {
        getUserCreated: (state) => {
            if (state.userCreated !== null) return state.userCreated

            if (localStorage.getItem('userCreated') !== null)
                state.userCreated = localStorage.getItem('userCreated')

            return state.userCreated
        },
        getProcessing: (state) => {
            return state.processing
        },
        getGivenName: (state) => {
            if (state.givenName) return state.givenName

            if (localStorage.getItem('givenName')) state.givenName = localStorage.getItem('givenName')

            return state.givenName
        },
        getFamilyName: (state) => {
            if (state.familyName) return state.familyName

            if (localStorage.getItem('familyName')) state.familyName = localStorage.getItem('familyName')

            return state.familyName
        },
        getEmail: (state) => {
            if (state.email) return state.email

            if (localStorage.getItem('email')) state.email = localStorage.getItem('email')

            return state.email
        },
        getPhoneNumber: (state) => {
            if (state.phoneNumber) return state.phoneNumber

            if (localStorage.getItem('phoneNumber'))
                state.phoneNumber = localStorage.getItem('phoneNumber')
            return state.phoneNumber
        },
        getFullName: (state) => {
            // return 'Simon Egebjerg Jensen'
            if (state.fullName) return state.fullName

            if (localStorage.getItem('fullName')) state.fullName = localStorage.getItem('fullName')
            return state.fullName
        },

        getUserLoggedInToCustomerPortalApi: (state) => {
            if (state.userLoggedInToCustomerPortalApi) return state.userLoggedInToCustomerPortalApi

            if (localStorage.getItem('userLoggedInToCustomerPortalApi')) state.userLoggedInToCustomerPortalApi = localStorage.getItem('userLoggedInToCustomerPortalApi')
            return state.userLoggedInToCustomerPortalApi
        },
        getUserLoggedIn: (state) => {
            if (state.userLoggedIn) return state.userLoggedIn

            if (localStorage.getItem('userLoggedIn')) state.userLoggedIn = localStorage.getItem('userLoggedIn')
            return state.userLoggedIn
        },

        getAddress: (state) => {
            if (state.address) return state.address

            if (localStorage.getItem('address')) state.address = localStorage.getItem('address')

            return state.address
        },
        getZipCode: (state) => {
            if (state.zipCode) return state.zipCode

            if (localStorage.getItem('zipCode')) state.zipCode = localStorage.getItem('zipCode')

            return state.zipCode
        },
        getCity: (state) => {
            if (state.city) return state.city

            if (localStorage.getItem('city')) state.city = localStorage.getItem('city')

            return state.city
        },

        getCriiptoIdentifier: (state) => {
            if (state.criiptoIdentifier) return state.criiptoIdentifier

            if (localStorage.getItem('criiptoIdentifier'))
                state.criiptoIdentifier = localStorage.getItem('criiptoIdentifier')

            return state.criiptoIdentifier
        },
        getSSN: (state) => {
            if (state.ssn) return state.ssn

            if (localStorage.getItem('ssn')) state.ssn = localStorage.getItem('ssn')

            return state.ssn
        },
        getCriiptoJwtToken: (state) => {
            if (state.criiptoJwtToken) return state.criiptoJwtToken

            if (localStorage.getItem('criiptoJwtToken'))
                state.criiptoJwtToken = localStorage.getItem('criiptoJwtToken')

            return state.criiptoJwtToken
        },
        getCriiptoTestMode: (state) => {
            return state.criiptoTestMode
        }
    },
    mutations: {
        setUserCreated: (state, userCreated) => {
            state.userCreated = userCreated

            localStorage.setItem('userCreated', userCreated)
        },
        setUserLoggedIn: (state, value) => {
            state.userLoggedIn = value
            localStorage.setItem('userLoggedIn', value.toString())
        },
        setUserLoggedInToCustomerPortalApi: (state, value) => {
            state.userLoggedInToCustomerPortalApi = value
            localStorage.setItem('userLoggedInToCustomerPortalApi', value.toString())
        },
        setProcessing: (state) => {
            state.processing = true
        },
        unsetProcessing: (state) => {
            state.processing = false
        },
        setGivenName: (state, givenName) => {
            state.givenName = givenName

            localStorage.setItem('givenName', givenName)
        },
        setFamilyName: (state, familyName) => {
            state.familyName = familyName

            localStorage.setItem('familyName', familyName)
        },
        setEmail: (state, email) => {
            state.email = email

            localStorage.setItem('email', email)
        },
        setPhoneNumber: (state, phoneNumber) => {
            state.phoneNumber = phoneNumber

            localStorage.setItem('phoneNumber', phoneNumber)
        },
        setFullName: (state, fullName) => {
            state.fullName = fullName

            localStorage.setItem('fullName', fullName)
        },

        setAddress: (state, address) => {
            state.address = address

            localStorage.setItem('address', address)
        },
        setZipCode: (state, zipCode) => {
            state.zipCode = zipCode

            localStorage.setItem('zipCode', zipCode)
        },
        setCity: (state, city) => {
            state.city = city

            localStorage.setItem('city', city)
        },
        setCriiptoJwtToken: (state, criiptoJwtToken) => {
            state.criiptoJwtToken = criiptoJwtToken

            localStorage.setItem('criiptoJwtToken', criiptoJwtToken)
        },

        setCriiptoIdentifier: (state, criiptoIdentifier) => {
            state.criiptoIdentifier = criiptoIdentifier

            localStorage.setItem('criiptoIdentifier', criiptoIdentifier)
        },
        removeCriiptoJwtToken: (state) => {
            state.criiptoJwtToken = null

            localStorage.removeItem('criiptoJwtToken')
        },
        setSSN: (state, ssn) => {
            state.ssn = ssn

            localStorage.setItem('ssn', ssn)
        },
        clearLocalStorage: () => {
            localStorage.clear()
        },
        setCriiptoTestMode: (state, testMode) => {
            state.criiptoTestMode = testMode
        }
    },
    actions: {
        fetchLoginCriipto: async ({commit, state}, {jwtToken, loginType, cvr}) => {
            await logInCriipto(jwtToken, loginType, cvr, state.criiptoTestMode).then((response) => {
                if (response.status === 200 && response.data.access_token) {
                    console.log('CriiptoTestLoginState:', state.criiptoTestMode)
                    // If the return is positive and we have an access token. we save it in local storage
                    localStorage.setItem('token', response.data.access_token)
                    localStorage.setItem('refreshtoken', response.data.refresh_token)

                    return true
                }
                return false
            })
        },
        setUserLoggedIn({commit}, value) {
            console.log('setUserLoggedIn', value)
            commit('setUserLoggedIn', value)
        },
        setUserLoggedInToCustomerPortalApi({commit}, value) {
            console.log('setUserLoggedInToCustomerPortalApi', value)
            commit('setUserLoggedInToCustomerPortalApi', value)
        },

        fetchUser: async ({commit}) => {
            const response = await getUser()
            const user = response.data

            if (user) {
                commit('setUserCreated', user.created)
                if (user.created) {
                    commit('setEmail', user.email)
                    commit('setPhoneNumber', user.phoneNumber)
                    commit('setAddress', user.address)
                    commit('setZipCode', user.zipCode)
                    commit('setCity', user.city)
                }
            }
        },
        fetchAllowedOrganisations: async ({commit},) => {
            const response = await getAllowedOrganisations()
            if (response.status === 200) {
                return response.data
            } else {
                throw new Error('No allowed organisations found.')
            }
        },
        createPrivateCustomer: async ({commit}, {
            verificationCode,
            name,
            email,
            phoneNumber,
            address,
            zipCode,
            city
        }) => {
            const response = await createPrivateCustomer(
                verificationCode,
                name,
                email,
                phoneNumber,
                address,
                zipCode,
                city
            )
            commit('setUserCreated', true)
            return response.data
        },
        fetchCustomerRegistrationRelations: async (_,) => {
            const response = await fetchCustomerRegistrationRelations()
            return response.data
        },
        deleteCustomerRegistrationRelation: async (_, payload) => {
            const response = await deleteCustomerRegistrationRelation(
                payload.id
            )
            return response.data
        },
        fetchVehicleInformation: async (_, payload) => {
            const response = await fetchVehicleInformation(
                payload.registrationNumber
            )
            return response.data
        },
        createCustomerRegistrationRelation: async (_, payload) => {
            const response = await createCustomerRegistrationRelation(
                payload.registrationNumber
            )
            return response.data
        },
        generateUserVerificationCode: async (_, payload) => {
            const response = await generateUserVerificationCode(payload.email)
            return response.data
        }
    }
}
